// src/utils/ViewReport/viewReportSync.js

/**
 * Sync utilities for view-report data to Firestore.
 * Mirrors the pattern from src/utils/Onboarding/sync.js
 */

import { getUtcIsoTimestamp } from './viewReportSession.js';

export function buildViewReportSyncPayload(viewReportState) {
  if (!viewReportState) {
    return {
      session: null,
      fields: {},
      dirtyFields: [],
      generatedAt: getUtcIsoTimestamp(),
    };
  }

  return {
    session: {
      id: viewReportState.session?.id || null,
      requestId: viewReportState.session?.requestId || null,
      createdAt: viewReportState.session?.createdAt || null,
      lastUpdatedAt: viewReportState.session?.lastUpdatedAt || null,
    },
    fields: { ...(viewReportState.latestValues || {}) },
    dirtyFields: Object.keys(viewReportState.dirtyFields || {}),
    generatedAt: getUtcIsoTimestamp(),
  };
}

export function computeViewReportLocalFingerprint(viewReportState) {
  if (!viewReportState) return null;
  try {
    const baseline = {
      sessionId: viewReportState.session?.id || null,
      lastUpdatedAt: viewReportState.session?.lastUpdatedAt || null,
      dirtyFields: Object.keys(viewReportState.dirtyFields || {}).sort(),
      latestValues: viewReportState.latestValues || {},
    };
    return JSON.stringify(baseline);
  } catch (error) {
    console.error('[ViewReportSync] Failed to compute fingerprint:', error);
    return null;
  }
}
